import { render } from "./MakeFriends.vue?vue&type=template&id=18b92138&scoped=true"
import script from "./MakeFriends.vue?vue&type=script&lang=js"
export * from "./MakeFriends.vue?vue&type=script&lang=js"

import "./MakeFriends.vue?vue&type=style&index=0&id=18b92138&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b92138"]])

export default __exports__